import { toast } from 'material-react-toastify';

import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { userKeys } from '@/lib/query/keys/user';
import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';

export const useUserChatBalance = (userId: string | undefined) => {
  return useQuery<number>({
    queryKey: userKeys.chatBalance(userId ?? ''),
    queryFn: async () => {
      if (!userId) return 0;
      try {
        const token = await getAuthToken();
        const {
          data: { balance },
        } = await hubApi.getChatBalanceHub(userId, withAuthHeader(token));

        return balance;
      } catch (error) {
        Sentry.captureException(`Failed to fetch subscriptions: ${error.message}`);
        toast.error(`Failed to fetch subscriptions: ${error.message}`);
        return 0;
      }
    },
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
  });
};
